"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _Carrier = _interopRequireDefault(require("./Carrier"));

var _Company = _interopRequireDefault(require("./Company"));

var _ServiceLevel = _interopRequireDefault(require("./ServiceLevel"));

var _ShipmentMode = _interopRequireDefault(require("./ShipmentMode"));

var _SlimUser = _interopRequireDefault(require("./SlimUser"));

var _TenderBase = _interopRequireDefault(require("./TenderBase"));

var _TenderChargeLineItem = _interopRequireDefault(require("./TenderChargeLineItem"));

var _TenderGetAllOf = _interopRequireDefault(require("./TenderGetAllOf"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The TenderGet model module.
 * @module model/TenderGet
 * @version 2.7.64
 */
var TenderGet = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>TenderGet</code>.
   * @alias module:model/TenderGet
   * @implements module:model/TenderBase
   * @implements module:model/TenderGetAllOf
   * @param createdByCompanyId {String} UUID of company that created this tender
   * @param id {String} UUID of this tender
   */
  function TenderGet(createdByCompanyId, id) {
    _classCallCheck(this, TenderGet);

    _TenderBase["default"].initialize(this);

    _TenderGetAllOf["default"].initialize(this, createdByCompanyId, id);

    TenderGet.initialize(this, createdByCompanyId, id);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(TenderGet, null, [{
    key: "initialize",
    value: function initialize(obj, createdByCompanyId, id) {
      obj['created_by_company_id'] = createdByCompanyId;
      obj['id'] = id;
    }
    /**
     * Constructs a <code>TenderGet</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TenderGet} obj Optional instance to populate.
     * @return {module:model/TenderGet} The populated <code>TenderGet</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new TenderGet();

        _TenderBase["default"].constructFromObject(data, obj);

        _TenderGetAllOf["default"].constructFromObject(data, obj);

        if (data.hasOwnProperty('charge_line_items')) {
          obj['charge_line_items'] = _ApiClient["default"].convertToType(data['charge_line_items'], [_TenderChargeLineItem["default"]]);
        }

        if (data.hasOwnProperty('contract')) {
          obj['contract'] = _ApiClient["default"].convertToType(data['contract'], 'String');
        }

        if (data.hasOwnProperty('delivery_date')) {
          obj['delivery_date'] = _ApiClient["default"].convertToType(data['delivery_date'], 'Date');
        }

        if (data.hasOwnProperty('earliest_pickup_date')) {
          obj['earliest_pickup_date'] = _ApiClient["default"].convertToType(data['earliest_pickup_date'], 'Date');
        }

        if (data.hasOwnProperty('earliest_pickup_time')) {
          obj['earliest_pickup_time'] = _ApiClient["default"].convertToType(data['earliest_pickup_time'], 'String');
        }

        if (data.hasOwnProperty('equipment_type')) {
          obj['equipment_type'] = _ApiClient["default"].convertToType(data['equipment_type'], 'String');
        }

        if (data.hasOwnProperty('error_message')) {
          obj['error_message'] = _ApiClient["default"].convertToType(data['error_message'], 'String');
        }

        if (data.hasOwnProperty('expires_at')) {
          obj['expires_at'] = _ApiClient["default"].convertToType(data['expires_at'], 'Date');
        }

        if (data.hasOwnProperty('info_message')) {
          obj['info_message'] = _ApiClient["default"].convertToType(data['info_message'], 'String');
        }

        if (data.hasOwnProperty('lane_type')) {
          obj['lane_type'] = _ApiClient["default"].convertToType(data['lane_type'], 'String');
        }

        if (data.hasOwnProperty('latest_pickup_date')) {
          obj['latest_pickup_date'] = _ApiClient["default"].convertToType(data['latest_pickup_date'], 'Date');
        }

        if (data.hasOwnProperty('latest_pickup_time')) {
          obj['latest_pickup_time'] = _ApiClient["default"].convertToType(data['latest_pickup_time'], 'String');
        }

        if (data.hasOwnProperty('reference_number')) {
          obj['reference_number'] = _ApiClient["default"].convertToType(data['reference_number'], 'String');
        }

        if (data.hasOwnProperty('transit_days')) {
          obj['transit_days'] = _ApiClient["default"].convertToType(data['transit_days'], 'Number');
        }

        if (data.hasOwnProperty('accepted_at')) {
          obj['accepted_at'] = _ApiClient["default"].convertToType(data['accepted_at'], 'Date');
        }

        if (data.hasOwnProperty('carrier')) {
          obj['carrier'] = _Carrier["default"].constructFromObject(data['carrier']);
        }

        if (data.hasOwnProperty('carrier_status')) {
          obj['carrier_status'] = _ApiClient["default"].convertToType(data['carrier_status'], 'String');
        }

        if (data.hasOwnProperty('created_at')) {
          obj['created_at'] = _ApiClient["default"].convertToType(data['created_at'], 'Date');
        }

        if (data.hasOwnProperty('created_by_company_id')) {
          obj['created_by_company_id'] = _ApiClient["default"].convertToType(data['created_by_company_id'], 'String');
        }

        if (data.hasOwnProperty('created_by_user_id')) {
          obj['created_by_user_id'] = _ApiClient["default"].convertToType(data['created_by_user_id'], 'String');
        }

        if (data.hasOwnProperty('external_edi_system_shipment_id')) {
          obj['external_edi_system_shipment_id'] = _ApiClient["default"].convertToType(data['external_edi_system_shipment_id'], 'String');
        }

        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'String');
        }

        if (data.hasOwnProperty('involved_tender_to_company_users')) {
          obj['involved_tender_to_company_users'] = _ApiClient["default"].convertToType(data['involved_tender_to_company_users'], [_SlimUser["default"]]);
        }

        if (data.hasOwnProperty('mode')) {
          obj['mode'] = _ShipmentMode["default"].constructFromObject(data['mode']);
        }

        if (data.hasOwnProperty('rejected_at')) {
          obj['rejected_at'] = _ApiClient["default"].convertToType(data['rejected_at'], 'Date');
        }

        if (data.hasOwnProperty('revoked_at')) {
          obj['revoked_at'] = _ApiClient["default"].convertToType(data['revoked_at'], 'Date');
        }

        if (data.hasOwnProperty('service_level')) {
          obj['service_level'] = _ServiceLevel["default"].constructFromObject(data['service_level']);
        }

        if (data.hasOwnProperty('shipment_id')) {
          obj['shipment_id'] = _ApiClient["default"].convertToType(data['shipment_id'], 'String');
        }

        if (data.hasOwnProperty('status')) {
          obj['status'] = _ApiClient["default"].convertToType(data['status'], 'String');
        }

        if (data.hasOwnProperty('tender_to_company')) {
          obj['tender_to_company'] = _Company["default"].constructFromObject(data['tender_to_company']);
        }

        if (data.hasOwnProperty('updated_at')) {
          obj['updated_at'] = _ApiClient["default"].convertToType(data['updated_at'], 'Date');
        }
      }

      return obj;
    }
  }]);

  return TenderGet;
}();
/**
 * @member {Array.<module:model/TenderChargeLineItem>} charge_line_items
 */


TenderGet.prototype['charge_line_items'] = undefined;
/**
 * ID of the Contract that whose details were used to create the tender, if applicable
 * @member {String} contract
 */

TenderGet.prototype['contract'] = undefined;
/**
 * requested delivery date for this tender (in YYYY-MM-DD format)
 * @member {Date} delivery_date
 */

TenderGet.prototype['delivery_date'] = undefined;
/**
 * Earliest date tender is available for pickup (in YYYY-MM-DD format)
 * @member {Date} earliest_pickup_date
 */

TenderGet.prototype['earliest_pickup_date'] = undefined;
/**
 * Earliest time tender is available for pickup (in HH:MM:SS format)
 * @member {String} earliest_pickup_time
 */

TenderGet.prototype['earliest_pickup_time'] = undefined;
/**
 * machine_readable string of the EquipmentType requested for this tender.
 * @member {String} equipment_type
 */

TenderGet.prototype['equipment_type'] = undefined;
/**
 * Open-ended field for error information regarding this tender
 * @member {String} error_message
 */

TenderGet.prototype['error_message'] = undefined;
/**
 * Datetime the tender expires or null if it doesn't expire.
 * @member {Date} expires_at
 */

TenderGet.prototype['expires_at'] = undefined;
/**
 * Open-ended field for other information regarding this tender e.g special instructions
 * @member {String} info_message
 */

TenderGet.prototype['info_message'] = undefined;
/**
 * machine_readable string of the LaneType (formerly QuoteLaneType) requested for this tender.
 * @member {module:model/TenderGet.LaneTypeEnum} lane_type
 */

TenderGet.prototype['lane_type'] = undefined;
/**
 * Latest date tender is available for pickup (in YYYY-MM-DD format)
 * @member {Date} latest_pickup_date
 */

TenderGet.prototype['latest_pickup_date'] = undefined;
/**
 * Latest time tender is available for pickup (in HH:MM:SS format)
 * @member {String} latest_pickup_time
 */

TenderGet.prototype['latest_pickup_time'] = undefined;
/**
 * Reference number/string for this tender. Primarially for references from external systems.
 * @member {String} reference_number
 */

TenderGet.prototype['reference_number'] = undefined;
/**
 * Number of days scheduled for transit
 * @member {Number} transit_days
 */

TenderGet.prototype['transit_days'] = undefined;
/**
 * Datetime that the tender was accepted at or null if not accepted.
 * @member {Date} accepted_at
 */

TenderGet.prototype['accepted_at'] = undefined;
/**
 * @member {module:model/Carrier} carrier
 */

TenderGet.prototype['carrier'] = undefined;
/**
 * @member {module:model/TenderGet.CarrierStatusEnum} carrier_status
 */

TenderGet.prototype['carrier_status'] = undefined;
/**
 * @member {Date} created_at
 */

TenderGet.prototype['created_at'] = undefined;
/**
 * UUID of company that created this tender
 * @member {String} created_by_company_id
 */

TenderGet.prototype['created_by_company_id'] = undefined;
/**
 * UUID of user that created this tender (if known)
 * @member {String} created_by_user_id
 */

TenderGet.prototype['created_by_user_id'] = undefined;
/**
 * External system shipment identification value
 * @member {String} external_edi_system_shipment_id
 */

TenderGet.prototype['external_edi_system_shipment_id'] = undefined;
/**
 * UUID of this tender
 * @member {String} id
 */

TenderGet.prototype['id'] = undefined;
/**
 * @member {Array.<module:model/SlimUser>} involved_tender_to_company_users
 */

TenderGet.prototype['involved_tender_to_company_users'] = undefined;
/**
 * @member {module:model/ShipmentMode} mode
 */

TenderGet.prototype['mode'] = undefined;
/**
 * Datetime the tender was rejected or null if not rejected.
 * @member {Date} rejected_at
 */

TenderGet.prototype['rejected_at'] = undefined;
/**
 * Datetime the tender was revoked by the shipper or null if not revoked.
 * @member {Date} revoked_at
 */

TenderGet.prototype['revoked_at'] = undefined;
/**
 * @member {module:model/ServiceLevel} service_level
 */

TenderGet.prototype['service_level'] = undefined;
/**
 * UUID of the shipment this tender is for
 * @member {String} shipment_id
 */

TenderGet.prototype['shipment_id'] = undefined;
/**
 * @member {module:model/TenderGet.StatusEnum} status
 */

TenderGet.prototype['status'] = undefined;
/**
 * @member {module:model/Company} tender_to_company
 */

TenderGet.prototype['tender_to_company'] = undefined;
/**
 * @member {Date} updated_at
 */

TenderGet.prototype['updated_at'] = undefined; // Implement TenderBase interface:

/**
 * @member {Array.<module:model/TenderChargeLineItem>} charge_line_items
 */

_TenderBase["default"].prototype['charge_line_items'] = undefined;
/**
 * ID of the Contract that whose details were used to create the tender, if applicable
 * @member {String} contract
 */

_TenderBase["default"].prototype['contract'] = undefined;
/**
 * requested delivery date for this tender (in YYYY-MM-DD format)
 * @member {Date} delivery_date
 */

_TenderBase["default"].prototype['delivery_date'] = undefined;
/**
 * Earliest date tender is available for pickup (in YYYY-MM-DD format)
 * @member {Date} earliest_pickup_date
 */

_TenderBase["default"].prototype['earliest_pickup_date'] = undefined;
/**
 * Earliest time tender is available for pickup (in HH:MM:SS format)
 * @member {String} earliest_pickup_time
 */

_TenderBase["default"].prototype['earliest_pickup_time'] = undefined;
/**
 * machine_readable string of the EquipmentType requested for this tender.
 * @member {String} equipment_type
 */

_TenderBase["default"].prototype['equipment_type'] = undefined;
/**
 * Open-ended field for error information regarding this tender
 * @member {String} error_message
 */

_TenderBase["default"].prototype['error_message'] = undefined;
/**
 * Datetime that this tender expires at.
 * @member {Date} expires_at
 */

_TenderBase["default"].prototype['expires_at'] = undefined;
/**
 * Open-ended field for other information regarding this tender e.g special instructions
 * @member {String} info_message
 */

_TenderBase["default"].prototype['info_message'] = undefined;
/**
 * machine_readable string of the LaneType (formerly QuoteLaneType) requested for this tender.
 * @member {module:model/TenderBase.LaneTypeEnum} lane_type
 */

_TenderBase["default"].prototype['lane_type'] = undefined;
/**
 * Latest date tender is available for pickup (in YYYY-MM-DD format)
 * @member {Date} latest_pickup_date
 */

_TenderBase["default"].prototype['latest_pickup_date'] = undefined;
/**
 * Latest time tender is available for pickup (in HH:MM:SS format)
 * @member {String} latest_pickup_time
 */

_TenderBase["default"].prototype['latest_pickup_time'] = undefined;
/**
 * Reference number/string for this tender. Primarially for references from external systems.
 * @member {String} reference_number
 */

_TenderBase["default"].prototype['reference_number'] = undefined;
/**
 * Number of days scheduled for transit
 * @member {Number} transit_days
 */

_TenderBase["default"].prototype['transit_days'] = undefined; // Implement TenderGetAllOf interface:

/**
 * Datetime that the tender was accepted at or null if not accepted.
 * @member {Date} accepted_at
 */

_TenderGetAllOf["default"].prototype['accepted_at'] = undefined;
/**
 * @member {module:model/Carrier} carrier
 */

_TenderGetAllOf["default"].prototype['carrier'] = undefined;
/**
 * @member {module:model/TenderGetAllOf.CarrierStatusEnum} carrier_status
 */

_TenderGetAllOf["default"].prototype['carrier_status'] = undefined;
/**
 * @member {Date} created_at
 */

_TenderGetAllOf["default"].prototype['created_at'] = undefined;
/**
 * UUID of company that created this tender
 * @member {String} created_by_company_id
 */

_TenderGetAllOf["default"].prototype['created_by_company_id'] = undefined;
/**
 * UUID of user that created this tender (if known)
 * @member {String} created_by_user_id
 */

_TenderGetAllOf["default"].prototype['created_by_user_id'] = undefined;
/**
 * Datetime the tender expires or null if it doesn't expire.
 * @member {Date} expires_at
 */

_TenderGetAllOf["default"].prototype['expires_at'] = undefined;
/**
 * External system shipment identification value
 * @member {String} external_edi_system_shipment_id
 */

_TenderGetAllOf["default"].prototype['external_edi_system_shipment_id'] = undefined;
/**
 * UUID of this tender
 * @member {String} id
 */

_TenderGetAllOf["default"].prototype['id'] = undefined;
/**
 * @member {Array.<module:model/SlimUser>} involved_tender_to_company_users
 */

_TenderGetAllOf["default"].prototype['involved_tender_to_company_users'] = undefined;
/**
 * @member {module:model/ShipmentMode} mode
 */

_TenderGetAllOf["default"].prototype['mode'] = undefined;
/**
 * Datetime the tender was rejected or null if not rejected.
 * @member {Date} rejected_at
 */

_TenderGetAllOf["default"].prototype['rejected_at'] = undefined;
/**
 * Datetime the tender was revoked by the shipper or null if not revoked.
 * @member {Date} revoked_at
 */

_TenderGetAllOf["default"].prototype['revoked_at'] = undefined;
/**
 * @member {module:model/ServiceLevel} service_level
 */

_TenderGetAllOf["default"].prototype['service_level'] = undefined;
/**
 * UUID of the shipment this tender is for
 * @member {String} shipment_id
 */

_TenderGetAllOf["default"].prototype['shipment_id'] = undefined;
/**
 * @member {module:model/TenderGetAllOf.StatusEnum} status
 */

_TenderGetAllOf["default"].prototype['status'] = undefined;
/**
 * @member {module:model/Company} tender_to_company
 */

_TenderGetAllOf["default"].prototype['tender_to_company'] = undefined;
/**
 * @member {Date} updated_at
 */

_TenderGetAllOf["default"].prototype['updated_at'] = undefined;
/**
 * Allowed values for the <code>lane_type</code> property.
 * @enum {String}
 * @readonly
 */

TenderGet['LaneTypeEnum'] = {
  /**
   * value: "DIRECT"
   * @const
   */
  "DIRECT": "DIRECT",

  /**
   * value: "INTERLINE"
   * @const
   */
  "INTERLINE": "INTERLINE",

  /**
   * value: "UNSPECIFIED"
   * @const
   */
  "UNSPECIFIED": "UNSPECIFIED"
};
/**
 * Allowed values for the <code>carrier_status</code> property.
 * @enum {String}
 * @readonly
 */

TenderGet['CarrierStatusEnum'] = {
  /**
   * value: "ACTIVE"
   * @const
   */
  "ACTIVE": "ACTIVE",

  /**
   * value: "INACTIVE"
   * @const
   */
  "INACTIVE": "INACTIVE",

  /**
   * value: "DO_NOT_USE"
   * @const
   */
  "DO_NOT_USE": "DO_NOT_USE"
};
/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */

TenderGet['StatusEnum'] = {
  /**
   * value: "open"
   * @const
   */
  "open": "open",

  /**
   * value: "accepted"
   * @const
   */
  "accepted": "accepted",

  /**
   * value: "rejected"
   * @const
   */
  "rejected": "rejected",

  /**
   * value: "revoked"
   * @const
   */
  "revoked": "revoked",

  /**
   * value: "expired"
   * @const
   */
  "expired": "expired"
};
var _default = TenderGet;
exports["default"] = _default;